// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.flex-container {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.space-evenly { \n  -webkit-box-pack: space-evenly; \n      -ms-flex-pack: space-evenly; \n          justify-content: space-evenly;\n}\n.date-field {\n  width: 40%;\n  display: inline-block;\n}\n\n", ""]);
// Exports
module.exports = exports;
